import EditCell from "components/custom/merchandise/cells/CommonEditCell";
import { METRIC_GROUPING_LOOKUP } from "../tables/metricsByEntity";
import type { Column } from "react-table-6";

export interface EditColumnOptions {
  columnTitle?: string;
  editCell: true;
  isStatic?: boolean;
  format?: string;
  validations?: { minValue?: number; maxValue?: number; blank?: boolean };
  toolTip: string;
  tabIndex?: number;
  overrideKey?: string;
  onValue?: string;
  offValue?: string;
  width?: number;
  className?: string;
  headerClassName?: string;
  toggleAction?: (row: unknown, updateValue: number | string | undefined) => void;
  strikeThroughText?: ((row: unknown) => string) | undefined;
  checked?: boolean;
  renderPlaceholderCellContent?: (row: unknown) => boolean;
  disabled?: boolean;
}

interface EditColumn extends Column {
  checked: boolean;
  isStatic?: boolean;
  grouping?: string;
  format?: string;
  height: number;
  onValue?: string;
  offValue?: string;
  toolTip: string;
  id: string;
}

const buildEditColumn = (
  title: string,
  marketPlace: { marketPlace: string },
  id: string,
  options: EditColumnOptions,
): EditColumn => {
  const { width, isStatic, checked, format, onValue, offValue, toolTip } = options;

  return {
    Header: title,
    id,
    accessor: id,
    checked: checked ?? true,
    isStatic,
    grouping: METRIC_GROUPING_LOOKUP[id],
    width,
    format,
    height: 30,
    onValue,
    offValue,
    toolTip,
    className: options.className,
    headerClassName: options.className,
    Cell: (props) => {
      const { row, column } = props;
      return (
        <EditCell
          row={row}
          value={
            options.overrideKey && row?._original?.[options.overrideKey] && !row?._original?.updated ?
              row?._original?.[options.overrideKey]
            : row?._original?.[column.id!]
          }
          column={column}
          options={options}
          marketPlace={marketPlace}
        />
      );
    },

    style: { height: "60px" },
  };
};

export default buildEditColumn;
